define(
    "diy/undo-redo/PluginRegistry",
    [
        'diy/undo-redo/plugins/Base'
    ],
    function (PluginBase) {
        'use strict';
        var
            PluginRegistry;

        /**
         * @class module.undoRedo.PluginRegistry
         * @template module.undoRedo.PluginRegistry
         * @lends {module.undoRedo.PluginRegistry.prototype}
         * @constructor
         */
        PluginRegistry = Klazz.extend({
            /**
             * @type {?Array.<module.undoRedo.plugins.Base>}
             */
            plugins: null,

            initialize: function () {
                this.plugins = [];
            },
            /**
             *
             * @param {module.undoRedo.plugins.Base} plugin
             * @returns {module.undoRedo.PluginRegistry}
             */
            register: function (plugin) {
                if (!plugin instanceof PluginBase) {
                    throw new Error();
                }
                this.plugins.push(plugin);
                plugin.markAsRegistered();
                return this;
            },
            /**
             * enables registered plugins based on featureSet
             * @toDo implement featureSet :)
             *
             * @param {module.undoRedo.FeatureSet} featureSet
             */
            enable: function (featureSet) {
                this.plugins.forEach(
                    /** @param {module.undoRedo.plugins.Base} plugin */
                    function (plugin) {
                        plugin.markAsEnabled();
                    }
                );
            },
            /**
             * calls onInit method on each registered plugin
             */
            init: function () {
                this.plugins.forEach(
                    /** @param {module.undoRedo.plugins.Base} plugin */
                    function (plugin) {
                        if (plugin.isEnabled()) {
                            plugin.onInit();
                        }
                    }
                );
            },
            /**
             *
             * @param entryType
             * @returns {module.undoRedo.plugins.Base|null|*}
             */
            getPluginFor: function getPluginFor(entryType) {

                var available = this.plugins.filter(
                    /** @param {module.undoRedo.plugins.Base} plugin */
                    function (plugin) {
                        return plugin.getType().indexOf(entryType) >= 0;
                    });
                if (available.length) {
                    return available[0];
                } else {
                    return null;
                }
            }
        });

        return PluginRegistry;
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/PluginRegistry.js
 ** module id = 891
 ** module chunks = 0
 **/